export const userMixins = {
	computed: {
		getUserName() {
			const {firstName, lastName} = this.getUserDetails();
			return `${firstName} ${lastName}`;
		},
		getUserInitial() {
			const {firstName, lastName} = this.getUserDetails();
			return `${firstName.charAt(0)}${lastName.charAt(0)}`;
		},
		getUserPets() {
			const { pets } = this.getUserDetails();
			return pets;
		},
		getActivePet() {
			return this.$store.getters.getActivePet;
		}
	},
	methods: {
		getUserDetails() {
			const userDetails = this.$store.getters.getUserDetails;
			const firstName = userDetails.firstName ? userDetails.firstName : '';
			const lastName = userDetails.lastName ? userDetails.lastName : '';
			const pets = userDetails.pets ? userDetails.pets : [];

			return { firstName, lastName, pets };
		},
		hasPetImage(index) {
			let hasImage = false;

			if (this.getUserPets[index]) {
				hasImage = !!this.getUserPets[index].imageUrl;
			}

			return hasImage;
		},
		getPetImage(index, isForActivePet, imageUrl) {
			let petImage = require('@/assets/images/_shared/dog-smile.svg');

			if (isForActivePet && imageUrl) {
				petImage = imageUrl;
			} else {
				if (this.hasPetImage(index)) {
					petImage = this.getUserPets[index].imageUrl;
				}
			}

			return petImage;
		},
		getUserPetName(index) {
			let petName = 'Pet Name';

			if (this.getUserPets[index]) {
				petName = this.getUserPets[index].name;
			}

			return petName;
		}
	}
}